import { render, staticRenderFns } from "./StatusCell.vue?vue&type=template&id=38b2d391&scoped=true"
import script from "./StatusCell.vue?vue&type=script&lang=js"
export * from "./StatusCell.vue?vue&type=script&lang=js"
import style0 from "./StatusCell.vue?vue&type=style&index=0&id=38b2d391&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b2d391",
  null
  
)

export default component.exports